module.exports = __webpack_public_path__ + "static/media/custom-15000-high.07297ff7.svg";